<div *ngIf="messageService.messages.length" id="messages">

</div>
